import React from 'react';
import PropTypes from 'prop-types';
import {
  BulkAssignTasksDialogContent,
  TaskAssignmentBulkActionDialogFooter
} from './components';
import { useBulkAssignTasksSubmit } from './hooks';

const BulkAssignTasksDialogBody = ({
  dialogDescribedById,
  impactedTaskCount,
  resource,
  projectId,
  textSearch,
  resetTaskAssignments,
  onTaskAssignmentUpdateSuccess,
  onClose,
  isRmpTaskAllocationEnhancement1
}) => {
  const {
    isBulkAssignTasksInProgress,
    handleBulkAssignTasksSubmit
  } = useBulkAssignTasksSubmit({
    projectId,
    resource,
    textSearch,
    resetTaskAssignments,
    onTaskAssignmentUpdateSuccess,
    onClose,
    isRmpTaskAllocationEnhancement1
  });

  return (
    <>
      <BulkAssignTasksDialogContent
        dialogDescribedById={dialogDescribedById}
        impactedTaskCount={impactedTaskCount}
        resourceName={resource.displayText}
        isBulkAssignTasksInProgress={isBulkAssignTasksInProgress}
      />
      <TaskAssignmentBulkActionDialogFooter
        onClose={onClose}
        onSubmit={handleBulkAssignTasksSubmit}
        isBulkActionInProgress={isBulkAssignTasksInProgress}
        confirmButtonTextId="taskAssignmentBulkActionDialog.assignAllTasks"
      />
    </>
  );
};

BulkAssignTasksDialogBody.propTypes = {
  dialogDescribedById: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  impactedTaskCount: PropTypes.number.isRequired,
  resource: PropTypes.object.isRequired,
  projectId: PropTypes.string.isRequired,
  textSearch: PropTypes.string,
  resetTaskAssignments: PropTypes.func.isRequired,
  onTaskAssignmentUpdateSuccess: PropTypes.func.isRequired,
  isRmpTaskAllocationEnhancement1: PropTypes.bool.isRequired
};

export default BulkAssignTasksDialogBody;
